/* src/components/input-counter/input-counter.component.scss */
:host {
  display: block;
  pointer-events: none;
}
.input-counter {
  font-size: 0.68rem;
  line-height: 1rem;
  color: var(--vwui-color-neutral-1);
  font-weight: var(--vwui-font-weight-semibold);
  text-align: right;
  margin: 0.3rem 0 -1.3rem 0;
}
.input-counter--has-error {
  color: var(--vwui-color-danger);
}
/*# sourceMappingURL=input-counter.component-N47SAPEO.css.map */
